module.exports = __webpack_public_path__ + "static/media/service-img-07.0021aa57.png";